export default __webpack_public_path__ + "static/media/misoya.2688e665.jpeg";